export default {
  state: {

  },
  mutations: {

  },
  action: {

  },
  getter: {

  }
}



// WEBPACK FOOTER //
// ./src/store/modules/login_id.js